  // Extract UTC offset from the time zone string
  export const extractUtcOffset = (timezoneStr) => {
    const regex = /\[([+-]\d{1,2}:\d{2})\]/; // Regular expression to match the UTC offset
    const match = regex.exec(timezoneStr);
    return match ? match[1] : null; // Return the UTC offset or null if not found
  };